const c = `<svg slot="icon" height="12px" width="12px" viewbox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" class="fallback-icon">
    <circle cx="6" cy="6" r="6" />
</svg>`;
export {
  c
};
